import { render } from "./ProductsToImport.vue?vue&type=template&id=49e897be"
import script from "./ProductsToImport.vue?vue&type=script&lang=js"
export * from "./ProductsToImport.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__